import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Checker } from "@/components/Checker";
import { HowItWorks } from "@/components/HowItWorks";
import { Metrics } from "@/components/Metrics";
import { Features } from "@/components/Features";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App bg-[#0B0F17] text-[#F3F4F6] min-h-screen">
      <Toaster theme="dark" position="bottom-right" richColors />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Checker />
        <HowItWorks />
        <Metrics />
        <Features />
      </main>
      <Footer />
    </div>
  );
}

export default App;
